import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const move: IMcAppType = {
  name: "move",
  path: "/my-account/move",
  description: "Book a moving data",
  navFlow: NavFlow.FOCUS,
  title: "Move",
  parent: Tab.MORE,
  conditions: {
    intent: "move",
    customerType: CustomerType.sap,
  },
};
